/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Stored property parameter identity, independent of any display preference.
 */
export enum PropertySharingField {
    OPERATION = 'operation',
    PROPERTY_TYPE = 'propertyType',
    COUNTRY_CODE = 'countryCode',
    REGION_CODE = 'regionCode',
    LOCALITY_CODE = 'localityCode',
    NEIGHBORHOOD = 'neighborhood',
    NAME = 'name',
    ID = 'id',
    SOURCE_ID = 'sourceId',
    SOURCE_CODE = 'sourceCode',
    SOURCE_SYSTEM = 'sourceSystem',
    MERCADO_LIBRE_CODE = 'mercadoLibreCode',
    LOCALITY = 'locality',
    REGION = 'region',
}
